import { render, staticRenderFns } from "./TotalDetailsToolbar.vue?vue&type=template&id=4f923218"
import script from "./TotalDetailsToolbar.vue?vue&type=script&lang=js"
export * from "./TotalDetailsToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports